module.exports = __webpack_public_path__ + "static/media/bnb-logo.790d94ab.png";